import "./Row.css";
import axios from "./axios";
import React, { useEffect, useState } from "react";
import YouTube from 'react-youtube';
import movieTrailer from 'movie-trailer';


function Row  ({ title, fetchUrl, 
    isLargeRow})  {
  const [movies, setMovies] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const request = await axios.get(fetchUrl);
    //   console.log(request.data.results);
      setMovies(request.data.results);

      return request;
    };
    fetchData(); 
  }, [fetchUrl]);
const opts={
    height:"390",
    width: "100%",
    playerVars:{
        autoplay:1,
    }
};

  const[trailerUrl,setTrailerUrl]= useState("");


   const handleClick=(movie)=>{
 if(trailerUrl){
    setTrailerUrl("");
 }
 else{
    movieTrailer(movie?.title || movie?.name|| movie.orignal_name)
        .then((url) =>{
        const urlParams= new URLSearchParams(new URL(url).search);
   setTrailerUrl(urlParams.get("v")); 
        })
        .catch((error)=>console.log(error));
    }
 
  };

  return (
    <div className="row ">
      {/* <div className=""> */}
        <h2 >{title}</h2>
        <div className="row__posters "
        
        >
          {movies.map((movie) => (
            <img
            onClick={()=>handleClick(movie)}
              src={`https://image.tmdb.org/t/p/original/${
                isLargeRow ? movie?.poster_path : movie?.backdrop_path
              }`}
              alt={movie.name}
              className={
              `row__poster ${isLargeRow &&"row__posterLarge"}`
           
              }
            />
          ))}
        </div>
        <div style={{padding:"40px"}}>
      {trailerUrl && <YouTube videoId={trailerUrl} opts={opts}/>}
        </div>
      {/* </div> */}
    </div>
  );
};

export default Row;
